import { createAction } from '@reduxjs/toolkit';

export const requestRetrieveFrequentlyAskedQuestions = createAction('help/retrieveFrequentlyAskedQuestions');
export const requestUpdateFrequentlyAskedQuestions = createAction('help/updateFrequentlyAskedQuestions');
export const requestCreateTutorial = createAction('help/createTutorial');
export const requestRetrieveTutorials = createAction('help/retrieveTutorials');
export const requestUpdateTutorial = createAction('help/updateTutorial');
export const requestDeleteTutorial = createAction('help/deleteTutorial');
